import { FAVORITES_SET_LOCAL_MODE, FAVORITES_RECEIVE, clearClientFavorites } from '../Actions/Favorites.action';

// This middleware tracks transition from logged in (isLocalMode: false) to logged out (isLocalMode: true)
// and clears client favorites ONLY on that transition, after cart state is settled.
let prevIsLocalMode = null;

const favoritesTransitionMiddleware = store => next => action => {
    const result = next(action);
    // Only check after favorites state is updated
    if (action.type === FAVORITES_SET_LOCAL_MODE || action.type === FAVORITES_RECEIVE) {
        const state = store.getState();
        const isLocalMode = state.favorites && state.favorites.isLocalMode;
        if (prevIsLocalMode === false && isLocalMode === true) {
            // Transitioned from logged in to logged out: clear client favorites
            store.dispatch(clearClientFavorites());
        }
        prevIsLocalMode = isLocalMode;
    }
    return result;
};

export default favoritesTransitionMiddleware;
